import { mediaSkeleton } from '../../widgets/plug/Skeleton/components/patterns';

export const skeleton = (width) => {
    return [
        {
            row: mediaSkeleton(
                width,
                { 0: [100], 576: [50, 50], 992: [33, 33, 33], 1200: [25, 25, 25, 25], 1400: [20, 20, 20, 20, 20] },
                [20, 20, 20, 20, 20]
            ),
            gap: 1,
            items: ['image']
        }
    ];
};
